export function ThreadApprovalNotice() {
  return <p className="mt-1 text-xs text-muted-foreground">Threads use auto-approve by default. Supervised runs ask for approval.</p>
}
